import { Radio } from "@blueprintjs/core";
import { FGSelectInput, FieldGroup, useFGContext } from "nsitools-react";
import * as React from "react";

import { ReferentialApi, ReferentialItemDto } from "../../../api";
import { useTl } from "../../../hooks";
import { useReferential } from "../../../hooks/useReferential";
import { ETLCodes } from "../../../locales";

export interface IFusionComboProps {
  elementName: string;
  elementNameBis: string;
  fusedElementName: string;
  label: ETLCodes;
  elementValue: any;
  elementValueBis: any;
  referentialFunc: (api: ReferentialApi) => Promise<ReferentialItemDto[]>;
  selectLeft?: boolean;
}

export const FusionCombo: React.FunctionComponent<IFusionComboProps> = ({
  elementName,
  elementNameBis,
  fusedElementName,
  label,
  elementValue,
  elementValueBis,
  referentialFunc,
  selectLeft = null,
}) => {
  const [fusionRadioValue, setFusionRadioValue] = React.useState(selectLeft !== null ? (selectLeft ? "1" : "2") : "1");
  const [oldFusionValue, setOldFusionValue] = React.useState(fusionRadioValue);
  const { formik } = useFGContext();
  const { t } = useTl();

  const [referentialValues, referentialValuesLoading] = useReferential(referentialFunc);

  React.useEffect(() => {
    setFusionRadioValue(selectLeft !== null ? (selectLeft ? "1" : "2") : "1");
  }, [selectLeft]);

  React.useEffect(() => {
    console.log("FusionRadioValue:", fusionRadioValue);
    console.log("OLD FusionRadioValue:", oldFusionValue);
    if (oldFusionValue !== fusionRadioValue) {
      if (fusionRadioValue === "1") {
        formik.setFieldValue(fusedElementName, elementValue);
      } else {
        formik.setFieldValue(fusedElementName, elementValueBis);
      }
      setOldFusionValue(fusionRadioValue);
    }
  }, [elementValue, elementValueBis, formik, fusedElementName, fusionRadioValue, oldFusionValue]);

  return (
    <>
      <div style={{ display: "flex" }}>
        <FieldGroup>
          <FieldGroup columns={[11, 1]}>
            <FGSelectInput
              name={elementName}
              label={t(label)}
              items={referentialValues}
              loading={referentialValuesLoading}
              readonly
            />

            <Radio
  style={{ margin: "0.4rem 0rem" }}
  value="1"
  checked={fusionRadioValue === "1"}
  onChange={(c) => {
    setFusionRadioValue(c.currentTarget.value);
    formik.setFieldValue(fusedElementName, elementValue);
  }}
  />
          </FieldGroup>
        </FieldGroup>
        {/*==================================================================================================*/}
        <FieldGroup>
          <div style={{ marginLeft: "14rem" }}>
            <FieldGroup columns={[11, 1]}>
              <FGSelectInput
                name={elementNameBis}
                label={t(label)}
                items={referentialValues}
                loading={referentialValuesLoading}
                readonly
              />
              <Radio
  style={{ margin: "0.4rem 0rem" }}
  value="2"
  checked={fusionRadioValue === "2"}
  onChange={(c) => {
    setFusionRadioValue(c.currentTarget.value);
    formik.setFieldValue(fusedElementName, elementValueBis);
  }}
  />
            </FieldGroup>
          </div>
        </FieldGroup>
      </div>
    </>
  );
};
